/**
 * The skin this bundle was built with (VITE_BRAND, see frontend/brand.mjs).
 * Names and colours are rewritten at build time; this covers the few places
 * where the skin changes structure rather than a string.
 */
export type BrandId = 'bogstars' | 'murzik';

type Brand = {
    id: BrandId;
    /** Two lines on the wheel's centre cap. */
    hub: [string, string];
    /** Splash artwork; null → the CSS spinner with the app name. */
    splashImage: string | null;
};

const BRANDS: Record<BrandId, Brand> = {
    bogstars: { id: 'bogstars', hub: ['BOG', 'STARS'], splashImage: '/loading/loading.gif' },
    murzik: { id: 'murzik', hub: ['MURZIK', 'STARS'], splashImage: null },
};

export const brand: Brand = BRANDS[import.meta.env.VITE_BRAND === 'murzik' ? 'murzik' : 'bogstars'];
